import { Component, OnInit, OnDestroy } from '@angular/core';
import { AsideToggleService } from './services/aside-toggle.service';
import { ExternalAuthService } from 'src/app/auth/external-auth.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
  selfLayout = 'default';
  sidebarCollapsed = false;
  canSeeIcalBanner = false;
  private sub: Subscription;

  constructor(
    private asideToggle: AsideToggleService,
    private authService: ExternalAuthService,
  ) {}

  ngOnInit(): void {
    this.sub = this.asideToggle.isMinimized$.subscribe(
      minimized => this.sidebarCollapsed = minimized
    );
    const role = this.authService.getCurrentUserInfo()?.role;
    this.canSeeIcalBanner = role !== 'it' && role !== 'logs';
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
